"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'multiple',
        ignore: true,
    },
    {
        key: 'defaultValue',
        ignore: true,
    },
    {
        key: 'dbIndex',
        ignore: true,
    },
];
